export default "__VITE_ASSET__vb4KRqut__"